import { GetServerSideProps } from "next";
import { ReactElement } from "react";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";
import dynamic from "next/dynamic";
const AtmMachinePricesWrapper = dynamic(
    () => import("@components/layouts/atmmachinepricesWrapper"),
);
export default function BestPostageMetersHome(): ReactElement {
    return (
        <AtmMachinePricesWrapper>
            <PrivacyPolicy
                category="Postage Meters"
                domain="BestPostageMeters.com"
            />
        </AtmMachinePricesWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
